
import "stylesheets/application.scss";
const images = require.context('../images', true);
var quiz_variant_tag = document.querySelector(`meta[name="quiz_variant"]`);
const quiz_variant = quiz_variant_tag && quiz_variant_tag.content;
global.quiz_variant = quiz_variant;

import kreawi_quiz_client from "../elm/kreawi_quiz_client/src/KreawiQuizClient";
global.kreawi_quiz_client = kreawi_quiz_client

global.kreawi_quiz_client_extras = require("../src/kreawi-quiz-client-extras.js");
